export const home = {
  // Hero
  hero: {
    tag: 'Language Education Infrastructure Reform Community',
    titleHighlight: '"Teaching"',
    titleRest: ', freer and',
    titleLine2: 'more accessible.',
    subtext:
      'EachTeach is a community where individual language tutors can deliver their best performance and everyone raises the quality of education together.',
    ctaRegister: 'Join the Community',
    ctaServices: 'View Services',
    scroll: 'SCROLL',
    stats: {
      categories: 'Categories',
      slaExperts: 'Expert Participation',
      possibilities: 'Learning Possibilities',
    },
  },

  // Philosophy
  philosophy: {
    label: 'Philosophy',
    visionLabel: 'Our Vision',
    visionQuote:
      'Fundamental reform of educational infrastructure through community support',
    heading: 'What EachTeach Aims For',
    paragraph1:
      'We aim to build a social infrastructure where individual language tutors can sustainably work as "independent educators." By creating a place where outstanding teachers are not isolated and can share their expertise and experience with one another, we raise the overall quality of language education.',
    paragraph2Before:
      'By applying the latest SLA (Second Language Acquisition) research to practice and spreading evidence-based teaching methods, we expand the possibilities of teaching. That is ',
    paragraph2Highlight: "EachTeach's core value",
    paragraph2After: '.',
    values: {
      independence: 'Independence',
      coCreation: 'Co-creation',
      expertise: 'Expertise',
      evidence: 'Evidence-based',
      diversity: 'Diversity',
    },
  },

  // Course Flow
  courseFlow: {
    label: 'Course Flow',
    heading: 'Course Flow',
    intro:
      'Starting from language exchange, learners progress through stepwise learning suited to their level while receiving tutor support.',
    step1Title: 'Language Exchange',
    step1Desc:
      'Start with language exchange. Through interaction with fellow learners and teachers, build the foundation for learning and find companions.',
    step2Title: 'Tutor Support',
    step2Desc:
      'Progress with the support of an individual tutor. Quality is ensured through expert feedback.',
    levelCourseTitle: 'Level-Based Courses',
    levelA: 'Beginner / Basics (A)',
    levelB1: 'Lower Intermediate (B1)',
    levelB2: 'Upper Intermediate (B2)',
    levelC: 'Advanced (C)',
    levelNote:
      'Advance through the A / B1 / B2 / C stages according to your current proficiency. The level check diagnoses the best starting point for you.',
  },

  // CTA Banner
  cta: {
    label: 'Join Us',
    heading: 'Why not join the community now?',
    subtext:
      'We welcome individual language tutors, aspiring teachers, SLA experts, and everyone else.',
    button: 'Join the Community',
  },
};
